import { render, staticRenderFns } from "./base-spinner.vue?vue&type=template&id=2cf6ce5f&scoped=true"
import script from "./base-spinner.vue?vue&type=script&setup=true&lang=js"
export * from "./base-spinner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-spinner.vue?vue&type=style&index=0&id=2cf6ce5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf6ce5f",
  null
  
)

export default component.exports